import log from '../helpers/log';
import errorCodes from './errorCodes';

export const POST_CONFIG = Object.freeze({
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'client_id': 'cct'
  },
  credentials: 'include',
});

export const GET_CONFIG = Object.freeze({
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'client_id': 'cct'
  },
  credentials: 'include',
});

/**
 * Calls member-api to determine if user is already logged in.
 */
export function isLoggedIn() {
    let url = window.REACT_APP_MEMBER_API_HOST + window.REACT_APP_IS_LOGGED_IN_PATH;

    return fetch(url, POST_CONFIG).then(function(fetchObj) {
      if (! fetchObj.ok) {
        let err = new Error('is logged in fetch failed');
        err.code = errorCodes.IS_LOGGED_IN_ERROR;
        return Promise.reject(err);
      }
      return fetchObj.json();
    }).then(function(response) {
      return response.loggedIn;
    });
}

/**
 * Calls member-api endpoint to retrieve member info.
 * A valid member-api session must have been established beforehand.
 * See "authWithAccessCode"
 */
export function getMemberInfo() {
  // necessary to load member data before getting alert data
  let url = window.REACT_APP_MEMBER_API_HOST + window.REACT_APP_MEMBERS_PATH;

  return fetch(url, GET_CONFIG).then(function(fetchObj) {
    log.info('getMemberInfo response=', fetchObj);
    return fetchObj.json();
  });
}

/**
 * Calls member-api endpoint to retrieve alert data.
 * "getMemberInfo" must have been called beforehand.
 */
export function getAlertList() {
  let url = window.REACT_APP_MEMBER_API_HOST + window.REACT_APP_ALERTS_PATH + '?bucket=inbox';

  // not passing account id defaults to primary member's alerts

  return fetch(url, GET_CONFIG).then((fetchObj) => {
    return fetchObj.json();
  }).then((data) => {
    log.info('alertList response=',data);

    return data;
  });
}

/**
 * Calls member-api endpoint to retrieve details for a single alert.
 * @param alertId
 * @returns {Promise} - the alert details
 */
export function getAlertDetail(alertId) {
  let url = window.REACT_APP_MEMBER_API_HOST + window.REACT_APP_ALERT_DETAIL_PATH + '/' + alertId;
  return fetch(url, GET_CONFIG).then((fetchObj) => {
    return fetchObj.json();
  }).then((data) => {
    log.info('alert detail=', data);
    return data;
  });
}


export function logToServer(data) {
  let url = window.REACT_APP_MEMBER_API_HOST + window.REACT_APP_LOG_PATH;
  let postConfig = {body: JSON.stringify([data])};
  Object.assign(postConfig, POST_CONFIG);
  return fetch(url, postConfig).then((fetchObj) => {
    return fetchObj.json();
  }).then((data) => {
    return data;
  });
}

export function startNslHandshake() {
  // calls member-api to discover NSL url for requesting access code
  let url = window.REACT_APP_MEMBER_API_HOST + window.REACT_APP_DISCOVER_NSL_PATH;
  let postConfig = {body: JSON.stringify({spaBundle: window.MODE})};
  Object.assign(postConfig, POST_CONFIG);
  log.debug('startnslhandshake postconfig',postConfig);

  return fetch(url, postConfig).then((fetchObj) => {
    return fetchObj.json();
  }).then((data) => {
    log.debug('startnslhandshake data=', data);

    //getNslAccessCode(data.redirectUri); // no ajax allowed with google oidc
    document.getElementById('authIframe').src=data.authUrlWithRedirect;  // will keep getting error when prompt=none in auth url and interaction required by IDP
    //window.open(data.authUrlWithRedirect);
  }).catch(function(error) {
    // TODO test url with //https://httpstat.us/500
    log.debug('nsl handshake error=', error);
  });
}

export function logout() {
  let url = window.REACT_APP_MEMBER_API_HOST + window.REACT_APP_LOGOUT_PATH;
  return fetch(url, GET_CONFIG).then((fetchObj) => {
    return fetchObj.json();
  }).then((data) => {
    return data;
  });
}

export default {
  getMemberInfo: getMemberInfo,
  getAlertDetail: getAlertDetail,
  getAlertList: getAlertList,
  isLoggedIn: isLoggedIn,
  logout: logout,
  logToServer: logToServer,
  startNslHandshake: startNslHandshake,
  GET_CONFIG: GET_CONFIG,
  POST_CONFIG: POST_CONFIG
};





// WEBPACK FOOTER //
// ./src/helpers/apiCalls.js